import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { StandardDialog } from "../../../../../../../shared/components/dialogs/StandardDialog"
import React from "react"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { Player } from "@lottiefiles/react-lottie-player"
import animation from "../../../../../../../shared/animations/succeededAnimation.json"
import { Box } from "@mui/system"

const useStyles = makeStyles()(() => ({
    title: {
        marginTop: "-3rem",
        paddingBottom: "2rem",
        textAlign: "center",
    },
    animationArea: {
        width: "10rem",
        height: "10rem",
        margin: "0 auto",
    },
}))

type ActivateAutoTopSuccessDialogProps = Readonly<{
    open: boolean
    onClose: () => void
}>

export function ActivateAutoTopSuccessDialog({ open, onClose }: ActivateAutoTopSuccessDialogProps) {
    const { classes } = useStyles()

    return (
        <StandardDialog open={open} onClose={onClose}>
            <LocalizedStrict id="user-wallets-refill-auto-activate-modal-title">
                <Typography variant="h4" className={classes.title}>
                    Activate auto top up
                </Typography>
            </LocalizedStrict>
            <Box className={classes.animationArea}>
                <Player src={animation} autoplay keepLastFrame />
            </Box>

            <LocalizedStrict id="user-wallets-refill-auto-activate-success-modal-subtitle">
                <Typography mt="3rem" textAlign="center" variant="subtitle1">
                    Auto top up activated
                </Typography>
            </LocalizedStrict>
        </StandardDialog>
    )
}

